import { JobEntity } from 'src/modules/jobs';

export enum JobsDetailsActions {
  FetchDetailsBegin = 'JOBS/FETCH_DETAILS/BEGIN',
  FetchDetailsSuccess = 'JOBS/FETCH_DETAILS/SUCCESS',
  FetchDetailsError = 'JOBS/FETCH_DETAILS/ERROR',
}

export interface JobsDetailsStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  job: JobEntity;
}
